export function titleize(sentence: string | null): string {
    if (!sentence) {
        return '';
    }

    const titleizeWord = (str: string) => {
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    };

    // split and capitalize after each non-word character
    return sentence.split(/(\W)/).map(titleizeWord).join('');
}
